import { Button } from 'components'
import { myPhoto } from 'assets'
import { AnimationOnScroll } from 'react-animation-on-scroll';
import "animate.css/animate.min.css";

type Props = {}

const skills = [
  "Javascript", "Typescript", "React", "NextJs", "React Native", "NodeJs", "Express", "AWS"
]

export const About = (props: Props) => {

  return (
    <section className='about_container' id="about">
      <span className='text-italic-open'>{"<about me>"}</span>
      <main>
        <div className="header_text" id="about-header">
          <h2 className='title'>about Me</h2>
          <h2 className='title'>about Me</h2>
        </div>
        <section>
          <div className="left">
          <AnimationOnScroll animateIn="animate__fadeInLeftBig" animateOnce={true}>
            <p className='about-me text-primary'>
              Hi, I'm
              <span className='my-name'> Muhyideen Akindele,</span>
              {" a senior software engineer with 7+ years building products across fintech, logistics, edtech, and Web3."}
              <br /><br />
              {"I care about the full picture: the architectural decision that keeps a codebase maintainable six months from now and the interaction detail that makes a user smile today. That balance between deep technical craft and genuine product thinking is what drives how I work."}
              <br /><br />
              {"Over the years I've led frontend teams, shipped AI-powered platforms used by thousands of users, redesigned high-traffic dashboards that cut support tickets in half and built on-chain interfaces for Africa's first Web3 startup launchpad. I like ownership, ambiguous problems and environments where the bar is high."}
              <br /><br />
              {"Outside of work, you'll find me swimming, running, watching football or making my way through a ridiculous number of browser tabs."}
            </p>
          </AnimationOnScroll>
            <br />
            <AnimationOnScroll animateIn="animate__fadeInLeftBig" delay={60} animateOnce={true}>
            <div className='skillset'>
              <p className='about-me text-primary'>I am skilled in the following technologies;</p>
              <ul>
                {skills.map((item, i) => (
                  <li style={{display: "flex"}} key={i}>
                    <Button btnType="secondary" text={item} className="text-secondary" />
                </li>
                ))}
              </ul>
            </div>
            </AnimationOnScroll>
          </div>
          
          <div className="right">
          <AnimationOnScroll animateIn="animate__fadeInRightBig" delay={40} animateOnce={true}>
            <div className="pics_box ">
              <img src={myPhoto} alt="" />
            </div>
            </AnimationOnScroll>
          </div>
        </section>
      </main>
      <span className='text-italic-close'>{"<about me>"}</span>
    </section>
  )
}

const PictureSlider = () => {
  return (
    <div className="gallery"> 
      <img src="/images/muy-1.jpg" alt="" />
      <img src="/images/headshot-min.jpg" alt="" />
      <img src="/images/muy-2.PNG" alt="" />
      {/* <img src="/images/muyi-4.jpg" alt="" /> */}
    </div>
  )
}